var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sui-scroll",
    {
      staticClass: "igc-subtab",
      style: { background: _vm.mBackground(17, "top", 16) },
      attrs: { horizontal: "" }
    },
    [
      _vm._l(_vm.tab.label, function(item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "ig--item",
            on: {
              click: function($event) {
                return _vm.$emit("switch-tab", item)
              }
            }
          },
          [
            _c("sui-image", {
              staticClass: "ig--image",
              attrs: { src: _vm.imageGetter(item) }
            }),
            _c(
              "div",
              {
                style: {
                  color:
                    item.id == _vm.active ? _vm.mColor(14) : _vm.mColor(15.1)
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          ],
          1
        )
      }),
      _vm.more
        ? _c(
            "div",
            {
              staticClass: "ig--all",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "label",
                    params: { category: _vm.tab.category, subcategory: 0 }
                  })
                }
              }
            },
            [
              _c("div", {
                staticClass: "ig--icon",
                style: {
                  "background-image": "url(" + _vm.imagePath + "/all.png)"
                }
              }),
              _c("div", { staticClass: "ig--placeholder" }, [_vm._v("占位")])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }